import { Brand } from '@src/Branding';

interface Config {
  VITE_BRAND: Brand;
  VITE_BRAND_EMAIL: string;
  VITE_BRAND_PHONE: string;
  VITE_BRAND_WEBFORM: string;
  VITE_BRAND_EXTENSION: string | undefined;
  VITE_DEV_BRAND_GOHIGHLEVEL_CHAT_WIDGET_ID_FR: string | undefined;
  VITE_DEV_BRAND_GOHIGHLEVEL_CHAT_WIDGET_ID_EN: string | undefined;
  VITE_ROLLBAR_ACCESS_TOKEN: string;
  VITE_ROLLBAR_ENV: string;
  VITE_API_URL: string;
  VITE_NUVEI_ENVIRONMENT: 'int' | 'prod';
  VITE_DEV_FLAG_DEV_WATERMARK: string | undefined;
  VITE_DEV_FLAG_PERMIT_MANAGER_AUTOFILL_EXTENSION: string | undefined;
  MUI_LICENSE_KEY: string;
}

const Config: Config = {
  VITE_BRAND: import.meta.env.VITE_BRAND || Brand.Nova,
  VITE_BRAND_EMAIL: import.meta.env.VITE_BRAND_EMAIL,
  VITE_BRAND_PHONE: import.meta.env.VITE_BRAND_PHONE,
  VITE_BRAND_WEBFORM: import.meta.env.VITE_BRAND_WEBFORM,
  VITE_BRAND_EXTENSION: import.meta.env.VITE_BRAND_EXTENSION,
  VITE_DEV_BRAND_GOHIGHLEVEL_CHAT_WIDGET_ID_FR: import.meta.env
    .VITE_DEV_BRAND_GOHIGHLEVEL_CHAT_WIDGET_ID_FR,
  VITE_DEV_BRAND_GOHIGHLEVEL_CHAT_WIDGET_ID_EN: import.meta.env
    .VITE_DEV_BRAND_GOHIGHLEVEL_CHAT_WIDGET_ID_EN,
  VITE_ROLLBAR_ACCESS_TOKEN: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  VITE_ROLLBAR_ENV: import.meta.env.VITE_ROLLBAR_ENV,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_NUVEI_ENVIRONMENT: import.meta.env.VITE_NUVEI_ENVIRONMENT,
  VITE_DEV_FLAG_DEV_WATERMARK: import.meta.env.VITE_DEV_FLAG_DEV_WATERMARK,
  VITE_DEV_FLAG_PERMIT_MANAGER_AUTOFILL_EXTENSION: import.meta.env
    .VITE_DEV_FLAG_PERMIT_MANAGER_AUTOFILL_EXTENSION,
  MUI_LICENSE_KEY:
    'e74129f882f3df1191339095926b78fdTz0xMjYxOTEsRT0xODA1NjczNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=',
};

export default Config;
